import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppTopbar } from '../component/app.topbar';
import { AuthService } from '../../core/auth/auth.service';
import { LoadingComponent } from '../auth-check/loading/loading.component';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-main-layout',
    standalone: true,
    imports: [CommonModule, AppTopbar, RouterModule, LoadingComponent, ToastModule],
    templateUrl: './main-layout.component.html',
    styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
    constructor(
        public authService: AuthService
    ) {}
}
